export default __webpack_public_path__ + "static/media/arrow_down.ba38e231.svg";